import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';
import {
  FuelType,
  AvailabilityType,
} from 'pages/Map/components/FuelAvailabilityButton/constants';
import { RestrictionStatus } from 'dataSources/Typicode/stations/types/stationInfo';

const setRestrictions = (
  state: IState,
  action: PayloadAction<{
    serviceNtType: FuelType | string;
    mode: AvailabilityType;
    statuses: Array<RestrictionStatus>;
  }>,
) => {
  state.restrictions = action.payload;
};

export default setRestrictions;
